/** Main JS Loader */

import '../scss/main.scss';
import './main.js';